module.exports = __webpack_public_path__ + "img/company_icon.3d292946.svg";